export default (obj: Object) => Object.entries(obj).map(([key, value]) => ({ key, value }));
